{
  "en": {
    "analytics": {
      "labels": {
        "click_seen_by": "Click to see which customers have seen this",
        "click_shared_with": "Click to see which customers have seen this",
        "deleted": "Deleted",
        "deleted_item": "This item has been deleted and is not clickable anymore",
        "noCustomers": "No customers are assigned to this level yet.",
        "noCustomersSeen": "No customers have seen this yet.",
        "noCustomersUnseen": "All customers have seen this.",
        "noUnitAccess": "No unit access",
        "notSeen": "Not Seen ({number})",
        "seen": "Seen ({number})",
        "seenBy": "Seen by",
        "sharedWithMultipleUnits": "Shared with no units in {level_name} | Shared with 1 unit in {level_name} | Shared with {units_count} units in {level_name}",
        "sharedWithUnit": "Shared with {unit_name}",
        "units": "No Unit | One Unit | {count} Units",
        "views": "Views",
        "viewsCount": "No views | 1 view | {count} views"
      }
    }
  }
}
